import { createSlice } from "@reduxjs/toolkit";

export const disposicionesSlices = createSlice({
  name: "disposiciones",
  initialState: {
    value: [],
  },
  reducers: {
    addList: (state, action) => {
      //
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addList } = disposicionesSlices.actions;

export default disposicionesSlices.reducer;
